import DashboardWrapper from "components/lib/Global/DashboardWrapper";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import React from "react";

const PaystackCallBackUrl = () => {
  return (
    <div>
      <DashboardWrapper />
      <div className="flex justify-center">
        <SpinnerIcon />
      </div>
    </div>
  );
};

export default PaystackCallBackUrl;
